import { Component, Input, OnInit } from '@angular/core';
import { KitAudit, KitAuditNotice, KitAuditNotice_ItemInWrongKit, KitAuditSet } from '../kit-audit';

@Component({
  selector: 'audit-notice-display',
  templateUrl: './notice-display.component.html',
  styleUrls: ['./notice-display.component.css']
})
export class NoticeDisplayComponent implements OnInit {

  @Input() audit!: KitAudit;
  @Input() kit?: KitAuditSet;

  constructor() { }  

  ngOnInit(): void {
  }

  public displayNotices() {
    return this.audit.notices.filter(notice => {

      // Item In Wrong Kit notices only display when in the From or To kit
      if(notice instanceof KitAuditNotice_ItemInWrongKit
        && (this.kit != undefined && notice.CorrectKit != this.kit && notice.FoundInKit != this.kit)) return false;

      return true;
    });
  }

  public dismissNotification(notice: KitAuditNotice) {
    this.audit.notices.remove(notice);
  }
}
